import { createSelector } from '@reduxjs/toolkit'

import { selectBusinessPrioritiesState } from './selectBusinessPrioritiesState'

export const selectActiveView = createSelector(
  [selectBusinessPrioritiesState],
  (state) => state.activeView
)
